import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  padding: 10px 0 10px 20px;\n  cursor: pointer;\n  user-select: none;\n  transition: opacity 150ms ease-in-out;\n\n  &:active {\n    opacity: 0.5;\n  }\n\n  > label {\n    font-size: 14px;\n    font-weight: normal;\n    color: ", ";\n    outline: 0;\n  }\n\n  > input {\n    opacity: 0;\n  }\n\n  > input + label {\n    position: relative;\n    padding: 0 15px;\n    cursor: pointer;\n\n    &::before,\n    &::after {\n      box-sizing: border-box;\n      position: absolute;\n    }\n\n    &::before {\n      background-color: #fff;\n      border-radius: ", ";\n      border: solid 1px ", ";\n      content: '';\n      display: inline-block;\n      height: 20px;\n      left: -14px;\n      top: 0px;\n      width: 20px;\n    }\n\n    &::after {\n      content: none;\n      background-color: #fff;\n      border-radius: ", ";\n      box-shadow: ", ";\n      display: inline-block;\n      height: 10px;\n      left: -9px;\n      top: 5px;\n      width: 10px;\n    }\n\n    &:hover::before {\n      border-color: ", ";\n    }\n  }\n\n  > input:checked + label::after {\n    content: '';\n  }\n\n  > input:checked + label::before {\n    background-color: ", ";\n    border-color: rgba(0, 0, 0, 0);\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled from '../../utils/styling/styled-components';
import { RADIO_INPUT, RADIO_INPUT_LABEL } from '../../utils/testing/TestIDs';
var Container = styled.div(_templateObject(), function (props) {
  return props.theme.colors.slate;
}, function (props) {
  return props.theme.borderRadius.large;
}, function (props) {
  return props.theme.colors.stoneLight;
}, function (props) {
  return props.theme.borderRadius.large;
}, function (props) {
  return props.theme.shadows.smMedium;
}, function (props) {
  return props.theme.colors.stone;
}, function (props) {
  return props.theme.colors.green;
});

var RadioInput = function RadioInput(_ref) {
  var checked = _ref.checked,
      className = _ref.className,
      id = _ref.id,
      label = _ref.label,
      name = _ref.name,
      onChange = _ref.onChange,
      value = _ref.value;
  return /*#__PURE__*/React.createElement(Container, {
    className: className
  }, /*#__PURE__*/React.createElement("input", {
    checked: checked,
    "data-testid": RADIO_INPUT,
    defaultValue: value,
    id: id,
    name: name,
    onChange: onChange,
    type: "radio"
  }), /*#__PURE__*/React.createElement("label", {
    "data-testid": RADIO_INPUT_LABEL,
    htmlFor: id
  }, label));
};

export { RadioInput };